module.exports = __webpack_public_path__ + "static/media/blacksmith.880b7d7e.svg";